import type { TriageStaff } from './types';

/**
 * Triage identity registry.
 *
 * There is no backend staff-roster endpoint, so the consuming app feeds the
 * current user + staff roster (derived from the workspace bootstrap) at runtime
 * via {@link setTriageIdentity}. Components read through the getters below so no
 * mock identity is hard-wired. Mirrors the app's existing toast-bridge pattern.
 */

const FALLBACK_CURRENT_USER: TriageStaff = {
  id: '',
  name: 'You',
  initials: '',
  role: '',
  color: 'var(--ink-3)',
};

let staffRoster: TriageStaff[] = [];
let currentUserId = '';

export function setTriageIdentity(identity: {
  staff?: TriageStaff[];
  currentUserId?: string;
}): void {
  if (identity.staff) staffRoster = identity.staff;
  if (identity.currentUserId !== undefined) currentUserId = identity.currentUserId;
}

export function getTriageStaff(): TriageStaff[] {
  return staffRoster;
}

export function getTriageCurrentUserId(): string {
  return currentUserId;
}

export function getTriageCurrentUser(): TriageStaff {
  return (
    staffRoster.find((s) => s.id === currentUserId) ??
    staffRoster[0] ??
    FALLBACK_CURRENT_USER
  );
}
